import { IAppState } from '../../../AppModulesWrapper';

import { selectServiceById } from './selectServiceById';
import { EUnavailableReason } from '../../types/reducers/publishTerms';
import { selectActiveOrPromotionServiceId } from './selectActiveOrPromotionServiceId';
import { selectIsServicesEnabled } from './selectIsServicesEnabled';
import { selectIsPromotionPackageSelected } from './selectIsPromotionPackageSelected';

export function selectServiceUnavailableReason(state: IAppState): EUnavailableReason | null {
  const serviceId = selectActiveOrPromotionServiceId(state);
  const isServicesEnabled = selectIsServicesEnabled(state);
  const isPromotionPackageSelected = selectIsPromotionPackageSelected(state);

  if ((!isPromotionPackageSelected && !isServicesEnabled) || !serviceId) {
    return null;
  }

  const service = selectServiceById(serviceId, state);

  if (!service) {
    return null;
  }

  return service.unavailableReasonType;
}
